import React, { FC } from 'react'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { IAdditionalStops } from 'apps/marketplace/store/amQuoting/types'

interface IAdditionalStopsDividerProps {
  stops: IAdditionalStops[]
}

const useStyles = makeStyles(() => ({
  hr: {
    backgroundColor: brandColors.coolGray2,
    width: '16px',
    border: '1px solid',
    borderColor: brandColors.coolGray2,
  },
  numSpan: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    padding: '1px 4px',
    backgroundColor: brandColors.coolGray2,
    color: brandColors.coolGray8,
  },
  tooltip: {
    display: 'flex',
    alignItems: 'center',
    mb: 'auto',
  },
}))

/**
 * Multiple Stops Info + Tooltip
 * Used between first + last stops
 */
const AdditionalStopsDivider: FC<IAdditionalStopsDividerProps> = ({ stops }) => {
  const stopsBetween = stops.length

  const classes = useStyles()

  return (
    <Tooltip
      position='top'
      effect='solid'
      trigger={
        <Box display='flex' alignItems='center' mx={1}>
          <Box component='hr' className={classes.hr} />
          <Box component='span' className={classes.numSpan}>
            {stopsBetween}
          </Box>
          <Box component='hr' className={classes.hr} />
        </Box>
      }>
      {stops.map((stop, idx) => {
        const id = idx + 1
        return (
          <Box key={stop.id} className={classes.tooltip}>
            <Box>
              <Typography variant='caption'>
                Stop {id}: {stop.city}, {stop.stateCode}
              </Typography>
            </Box>
          </Box>
        )
      })}
    </Tooltip>
  )
}

export default AdditionalStopsDivider
